import React, { useState, useEffect } from 'react';
import { navigate } from 'gatsby';
import { useLayoutContext } from '../../../providers/LayoutProvider';
import { ReachButton } from '../../../components/ReachButton/ReachButton';
import { SmartLink } from '../../../components/SmartLink/SmartLink';
import './SearchResultsContainer.scss';

export interface SearchResultsContainerInputs {
    heading: string;
    pages: {
        date: Date;
        title: string;
        url: string;
        externalLink?: boolean;
    }[];
}

export const SearchResultsContainer = ({
    node,
    inline,
    queryParams,
}: {
    node: SearchResultsContainerInputs;
    inline?: boolean;
    queryParams?: string;
}) => {
    const { setSearchOpen, setSidebarExpanded } = useLayoutContext();
    const pageSet = 5;
    const [pageResults, setPageResults] = useState(pageSet);
    const targetHeading =
        typeof window !== `undefined` ? window.history?.state?.id : ``;

    const handleMorePages = () => {
        setPageResults(pageResults + pageSet);
    };
    const handleLessPages = () => {
        setPageResults(5);
    };
    const handleNavigateToSearch = (s) => {
        navigate(`/search?q=${queryParams}`, {
            state: { id: s },
        });
        setSidebarExpanded(false);
        setSearchOpen(false);
    };

    useEffect(() => {
        if (node.heading === targetHeading) {
            setPageResults(node.pages.length);
        }
    }, []);

    return (
        <div className="search-results-container light">
            <h3 className="typestack-eyebrow">{node.heading}</h3>
            <ul>
                {node.pages.slice(0, pageResults)?.map((page, index) => (
                    <li key={`${index}${page.title}`}>
                        <SmartLink
                            href={page.url}
                            onClick={(e) => {
                                e.preventDefault();
                                setSidebarExpanded(false);
                                setSearchOpen(false);
                                navigate(page.url);
                            }}
                            tabIndex={0}
                        >
                            {page.title}
                        </SmartLink>
                    </li>
                ))}
            </ul>
            {pageResults < node.pages.length && (
                <ReachButton
                    buttonStyle="borderless"
                    buttonIcon={{
                        icon: inline ? `ki-chevron-down` : `ki-chevron-right`,
                        position: `right`,
                    }}
                    onClick={() => {
                        inline
                            ? handleMorePages()
                            : handleNavigateToSearch(`${node.heading}`);
                    }}
                >
                    View More Results in {node.heading}
                </ReachButton>
            )}
            {inline &&
                node.pages.length > 5 &&
                pageResults >= node.pages.length && (
                    <ReachButton
                        buttonStyle="borderless"
                        buttonIcon={{
                            icon: `ki-chevron-up`,
                            position: `right`,
                        }}
                        onClick={handleLessPages}
                    >
                        View Less Results in {node.heading}
                    </ReachButton>
                )}
        </div>
    );
};
